import React, { useState, useContext, useEffect } from 'react'
import { Form, Grid, Button } from 'semantic-ui-react'
import { useForm } from 'react-hook-form'
import Swal from 'sweetalert2'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import styles from './customerSettings.module.css'
import {
  updateStaticAlertSettings,
  getCustomerSettings,
} from '../../../../services/customer/index'
import { CustomerViewContext } from '../customer-info-view/customerView'

const initialState = {
  notify: 'no',
  status: '',
}

const formValidator = {
  min: yup.string().required('Please type Critical Level').min(0, ''),
  mid: yup.string().required('Please type Normal Level'),
  notify: yup.string().required('Please select your option'),
  status: yup.string(),
}

const StaticAlertSettings = () => {
  const product = localStorage.getItem('product')
  const [notifyCheck, setNotifyCheck] = useState(initialState)
  const { customerSettings, setViewNetworkSettings } =
    useContext(CustomerViewContext)
  const [minLevel, setMinLevel] = useState('')
  const [midLevel, setMidLevel] = useState('')

  useEffect(() => {
    ;(async () => {
      Swal.showLoading()
      try {
        const queryParams = {
          product,
          id: customerSettings.tbCustomerId,
        }
        console.log(queryParams)
        const res = await getCustomerSettings(queryParams)
        const notify = { critical: false, warning: false }
        res.data.map((attr) => {
          const key = attr.id.attributeKey
          if (key === 'maxLevel') setValue('max', attr.longValue)
          if (key === 'midLevel') setValue('mid', attr.longValue)
          if (key === 'minLevel') setValue('min', attr.longValue)
          if (key === 'critical') notify.critical = attr.booleanValue
          if (key === 'warning') notify.warning = attr.booleanValue
          return null
        })
        if (notify.critical && notify.warning) {
          setValue('notify', 'yes')
          setValue('status', 'both')
          setNotifyCheck({ status: 'both', notify: 'yes' })
        } else if (notify.critical) {
          setValue('notify', 'yes')
          setValue('status', 'critical')
          setNotifyCheck({ status: 'critical', notify: 'yes' })
        } else if (notify.warning) {
          setValue('notify', 'yes')
          setValue('status', 'warning')
          setNotifyCheck({ status: 'warning', notify: 'yes' })
        } else {
          setValue('notify', 'no')
          setNotifyCheck((prevState) => ({ ...prevState, notify: 'no' }))
        }
        console.log('settings: ', res)
        Swal.close()
        console.log(res)
      } catch (e) {
        console.log(e)
        Swal.fire('Error Grabing Customer Settings', '', 'error')
      }
    })()
  }, [])

  const { register, handleSubmit, errors, getValues, setValue } = useForm({
    resolver: yupResolver(yup.object().shape(formValidator)),
  })

  // eslint-disable-next-line no-unused-vars
  const [maxError, setMaxError] = useState(false)
  const [limitErrors, setLimitErrors] = useState({
    minGtmid: false,
    midLtmin: false,
  })

  const checkMidErrors = (e) => {
    setMidLevel(e.target.value)
    if (e.target.value === '') {
      setLimitErrors((prevState) => ({ ...prevState, midLtmin: false }))
      return
    }
    if (getValues('min') !== '') {
      if (+e.target.value <= getValues('min')) {
        setLimitErrors((prevState) => ({ ...prevState, midLtmin: true }))
      } else {
        setLimitErrors((prevState) => ({
          ...prevState,
          midLtmin: false,
          minGtmid: false,
        }))
      }
    }
  }

  const checkMinErrors = (e) => {
    setMinLevel(e.target.value)
    if (e.target.value === '') {
      setLimitErrors((prevState) => ({ ...prevState, minGtmid: false }))
      return
    }
    if (getValues('mid') !== '') {
      if (+e.target.value >= getValues('mid')) {
        console.log('>mid: ', true)
        setLimitErrors((prevState) => ({ ...prevState, minGtmid: true }))
      } else {
        setLimitErrors((prevState) => ({
          ...prevState,
          minGtmid: false,
          midLtmin: false,
        }))
      }
    }
  }

  const submitHandler = (data) => {
    let valid = true
    const min = +getValues('min')
    const mid = +getValues('mid')
    Object.entries(limitErrors).map((key) => {
      if (key[1]) valid = false
      return null
    })

    if (min >= mid) {
      setLimitErrors((prevState) => ({ ...prevState, minGtmid: true }))
      valid = false
    } else {
      setLimitErrors((prevState) => ({ ...prevState, minGtmid: false }))
    }

    const body = { ...data, max: 100 }

    console.log('valid: ', valid)

    if (!valid) return

    Swal.showLoading()
    updateStaticAlertSettings(customerSettings.tbCustomerId, body).then(
      async (res) => {
        if (res.success) {
          await Swal.fire({
            title: 'Static Attributes Added Successfully!',
            confirmButtonColor: 'Green',
            icon: 'success',
          })
          setViewNetworkSettings(false)
        } else {
          Swal.fire({
            title: 'Error Adding Attributes!',
            confirmButtonColor: 'Red',
            icon: 'error',
          })
        }
      },
    )
  }

  const handleChange = (e) => {
    e.persist()
    console.log(e.target.value)
    setNotifyCheck((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }))
  }

  return (
    <div>
      <Form
        style={{
          backgroundColor: 'rgb(216, 231, 234)',
          padding: 10,
          borderRadius: 9,
        }}
        id="staticAlertForm"
        onSubmit={handleSubmit(submitHandler)}
        widths="equal"
      >
        <Form.Field>
          <h3 className={styles.formHeader}>Tank Level Settings</h3>
          <Grid columns={3}>
            <Grid.Row>
              <Grid.Column>
                <span style={{ color: 'black' }}>Critical Level %:</span>
                <input
                  ref={register}
                  type="number"
                  min={0}
                  max={100}
                  name="min"
                  onChange={checkMinErrors}
                  style={{
                    backgroundColor: errors.min ? '#ffe2e7' : null,
                  }}
                />
                <small style={{ color: 'red' }}>**</small>
                <br />
                <span>
                  Critical Level &lt;= {getValues('min') || minLevel}%
                </span>
                <br />

                <span className={styles.mandatory}>
                  {' '}
                  {errors.min ? errors.min.message : null}{' '}
                </span>
                {limitErrors.minGtmid && (
                  <>
                    <span className={styles.mandatory}>
                      critical level must be smaller than nomral level
                    </span>
                    <br />
                  </>
                )}
              </Grid.Column>
              <Grid.Column>
                <span style={{ color: 'black' }}>Normal Level %:</span>
                <input
                  ref={register}
                  type="number"
                  min={0}
                  max={100}
                  name="mid"
                  onChange={checkMidErrors}
                  style={{
                    backgroundColor: errors.mid ? '#ffe2e7' : null,
                  }}
                />
                <small style={{ color: 'red' }}>**</small>
                <br />
                <span>Normal Level &gt;= {getValues('mid') || midLevel}%</span>
                <br />
                <span className={styles.mandatory}>
                  {' '}
                  {errors.mid ? `- ${errors.mid.message}` : null}{' '}
                </span>
                {limitErrors.midLtmin && (
                  <>
                    <span className={styles.mandatory}>
                      normal level must be greater than critical level
                    </span>
                    <br />
                  </>
                )}
              </Grid.Column>

              <Grid.Column>
                <div
                  style={{
                    textAlign: 'center',
                    color: 'black',
                    height: '118px',
                    paddingTop: '30px',
                  }}
                >
                  <span>
                    {getValues('min') || minLevel}% &lt; Warning Level &lt;{' '}
                    {getValues('mid') || midLevel}%
                  </span>
                </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <hr />

          <h3 className={styles.formHeader}>Notification Settings</h3>
          <Grid columns={2}>
            <Grid.Row>
              <Grid.Column>
                <span style={{ color: 'black' }}>Notify Me?</span>
                <select
                  ref={register}
                  name="notify"
                  value={notifyCheck.notify}
                  onChange={handleChange}
                >
                  <option value="yes">Yes</option>
                  <option value="no" selected>
                    No
                  </option>
                </select>
                <small style={{ color: 'red' }}>**</small>
              </Grid.Column>
              {notifyCheck.notify === 'yes' ? (
                <Grid.Column>
                  <span style={{ color: 'black' }}>Notify Me On:</span>
                  <select
                    name="status"
                    ref={register}
                    value={notifyCheck.status}
                    onChange={handleChange}
                  >
                    <option value="warning">Warning</option>
                    <option value="critical">Critical</option>
                    <option value="both">Both</option>
                  </select>
                  <small style={{ color: 'red' }}>**</small>
                </Grid.Column>
              ) : null}
            </Grid.Row>
          </Grid>
        </Form.Field>
        <Form.Field>
          <hr />
          <Grid>
            <Grid.Column textAlign="center">
              <Button
                from="staticAlertForm"
                type="submit"
                className={styles.button}
                color="red"
              >
                Submit
              </Button>
            </Grid.Column>
          </Grid>
        </Form.Field>
      </Form>
    </div>
  )
}

export default StaticAlertSettings
